import { defineStore } from 'pinia';
import { Api } from '@/api/generated/Api';
const api = new Api();

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: null, // 使用者資訊
    userCertData: null, // 自然人憑證取得的資訊
    permissions: null, // 使用者權限
  }),
  getters: {},
  actions: {
    setUserInfo(user) {
      this.userInfo = user;
    },
    clearUserInfo() {
      this.userInfo = null;
    },
    async fetchPermissions() {
      if (!localStorage.getItem('token')) return (this.permissions = null);
      try {
        const permissions = await api.getPermissions();
        this.permissions = permissions.data;
        localStorage.setItem('permissions', permissions.data.role);
      } catch (error) {
        console.error('Failed to fetch permissions:', error);
        this.permissions = null;
      }
    },
  },
});
